export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11484.1e213b52.jpg";